import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import StatusContainer from "../../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";

const ScheduleInternalTransactionMultiReject = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rejectedTransactions, setRejectedTransactions] = useState([]);

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));

    const storedData = JSON.parse(
      sessionStorage.getItem("intSelectedScheduleCard"),
    );

    if (storedData?.length) {
      setRejectedTransactions(storedData?.[0]?.selectedDetails || []);
    }

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/internal_transaction_dashboard");
  };

  const rejectMoreSchedules = () => {
    navigate("/internal_transaction_dashboard/schedule_multi_approval");
  };

  const buttonRows = [
    [
      {
        btnText: "Reject more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: rejectMoreSchedules,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const RejectedScheduleList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions.map((account, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: account?.scheduled_name
                ?.toLowerCase()
                .split(" ")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" "),
              leftSubTitle: "Schedule name",

              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTextFontWeight: "semibold",
              rightTitleTextColor: "var(--text-primary)",
              hasRight: true,
              rightIcon: true,
              rightText: true,
              onClick: () =>
                navigate(
                  `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      title={rejectedTransactions.length && "Schedules rejected successfully."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection
        title={`Rejected schedules - ${rejectedTransactions.length}`}
      >
        <RejectedScheduleList transactions={rejectedTransactions} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ScheduleInternalTransactionMultiReject;
